export default {
  SELECT_CREATE(state, payload) {
    state.create.type = payload;
  },
  TOGGLE_SETTING_SURAT(state, payload) {
    state.settingSurat.isActive = payload;
  },
  TOGGLE_FORM_SIGNATURE(state, payload) {
    state.settingSurat.showFormSignature = payload;
  },
  SET_DETAIL_ID(state, id) {
    state.detail.id = id;
  },

  SELECT_EDIT(state, payload) {
    state.edit.type = payload;
  },
  SET_EDIT_ID(state, payload) {
    state.edit.id = payload;
  },
  SET_SETTING_SURAT_ID(state, payload) {
    state.settingSurat.suratId = payload;
  },

  TOGGLE_SHOW_SURAT(state, payload) {
    state.showSurat.isActive = payload;
  },

  SET_SHOW_SURAT_ID(state, payload) {
    state.showSurat.suratId = payload;
  },
};
